export default "__VITE_ASSET__Dr6fXuwc__"